import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["verifiedContainer", "verificationStatusContainer"]

  static values = { id: Number }

  connect() {
    var _this = this

    this.statusUpdatePoller = setInterval(function() {
      fetch(`${_this._apiEndpoint(_this.idValue)}&t=${new Date().getTime()}`,)
        .then(response => {
          if (response.ok) {
            return response.json()
          }

          // If the lead was deleted, for example, the request will return a 404.
          // In such case, no need to continue polling for the progress.
          clearInterval(_this.statusUpdatePoller)

          return
        })
        .then(json => {
          if (json.data.verification.status === "pending") {
            // continue polling
            return
          }

          clearInterval(_this.statusUpdatePoller)

          if (_this.hasVerifiedContainerTarget === false) {
            return
          }

          // We display the verification status icon and trigger the tooltip
          _this.verifiedContainerTarget.innerHTML = App.components.verificationIcon(json.data.verification.status, json.data.confidence_score)

          if (_this.hasVerificationStatusContainerTarget === false) {
            return
          }

          // We update the verification status column if present
          if (json.data.verification.status === "valid") {
            _this.verificationStatusContainerTarget.innerHTML = `<span class='lead-verification-status green'>${i18n.t("js.verification_status.valid")}</span>`
          }
          else if (json.data.verification.status === "accept_all") {
            _this.verificationStatusContainerTarget.innerHTML = `<span class='lead-verification-status dark-orange'>${i18n.t("js.verification_status.accept_all")}</span>`
          }
          else if (json.data.verification.status === "invalid") {
            _this.verificationStatusContainerTarget.innerHTML = `<span class='lead-verification-status red'>${i18n.t("js.verification_status.invalid")}</span>`
          }
          else if (json.data.verification.status === "webmail") {
            _this.verificationStatusContainerTarget.innerHTML = `<span class='lead-verification-status purple'>${i18n.t("js.verification_status.webmail")}</span>`
          }
          else if (json.data.verification.status === "disposable") {
            _this.verificationStatusContainerTarget.innerHTML = `<span class='lead-verification-status blue'>${i18n.t("js.verification_status.disposable")}</span>`
          }
          else if (json.data.verification.status === "unknown") {
            _this.verificationStatusContainerTarget.innerHTML = `<span class='lead-verification-status grey'>${i18n.t("js.verification_status.unknown")}</span>`
          }
        })
        .catch(err => {
          console.warn(`Error while updating the verification status of ${_this.idValue} (${err})`)
        })
    }, Math.floor(5000 + Math.random() * 5000))
  }

  disconnect() {
    if (this.statusUpdatePoller) {
      clearInterval(this.statusUpdatePoller)
    }
  }

  _apiEndpoint(id) {
    let apiDomain = ""
    if (window.rails_env === "production") {
      apiDomain = "https://hunter.io"
    }

    return `${apiDomain}/v2/leads/${id}?api_key=${gon.api_key}`
  }
}
